export const MAX_MONTHLY_BUDGET = 9999999;
export const MIN_MONTHLY_BUDGET = 50;

/**
 * The states a campaign integration can be displayed in, in the order the status filter lists them.
 * These are also the exact values the list endpoint's `statuses` parameter accepts, so the chip on
 * a card and the filter that hides it can never disagree.
 */
export const CAMPAIGN_INTEGRATION_STATUSES = ["active", "paused", "inactive"] as const;

export type CampaignIntegrationStatus = (typeof CAMPAIGN_INTEGRATION_STATUSES)[number];

export const CAMPAIGN_INTEGRATION_STATUS_CONFIG: Record<
  CampaignIntegrationStatus,
  { labelKey: string; variant: "success" | "warning" | "neutral" }
> = {
  active: { labelKey: "common.active", variant: "success" },
  paused: { labelKey: "common.paused", variant: "warning" },
  inactive: { labelKey: "common.inactive", variant: "neutral" },
};
